import { UnlockOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React, { useState } from 'react';
import { User } from '../../../models/Users';
import UserPermissionsModalForm from './UserPermissionsModalForm';

interface Props {
    refresh(): void;
    record: User;
    text: string;
}

export default function (props: Props) {

    const [show, setShow] = useState(false);

    return (<>
        <Tooltip title={props.text} placement='topRight'>
            <Button shape='circle' type='primary' icon={<UnlockOutlined />} onClick={() => setShow(true)} style={{ marginLeft: '5px' }} />
        </Tooltip>

        {show && <UserPermissionsModalForm show={show} close={() => setShow(false)} title={props.text} refresh={props.refresh} record={props.record} />}
    </>);
}